import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import history from "app/utils/history.js";

import * as serviceWorker from "./serviceWorker";
import App from "./app/App";
//import './index.css';

// third party style
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { SnackbarProvider } from "app/c1component/SnackbarContext";

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter history={history}>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </BrowserRouter>,
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
